import React from 'react';
import './LoadingLine.css'; // Import the styles

/**
 *
 * @param {Object} props
 * @param {"top" | "bottom"} props.position Position of the loading line. Default is "top".
 * @returns
 */
function LoadingLine (
    {
        position = 'top'
    }
) {
    const translatePosition = () => {
        switch (position) {
            case 'top':
                return 'top-0';
            case 'bottom':
                return 'bottom-0';
            default:
                return 'top-0';
        }
    };
    return (
        <div className={`loading-line-container absolute ${translatePosition()} left-0`}>
            <div
                className="loading-line"
            />
        </div>
    );
}

export default LoadingLine;